import { Trans as I18nTrans } from 'react-i18next';
import { ReactNode, ReactElement } from 'react';

interface TransProps {
  /** Translation key */
  i18nKey: string;
  /** Namespace (defaults to 'common') */
  ns?: string;
  /** Values to interpolate */
  values?: Record<string, unknown>;
  /** Components to replace tags in the translation */
  components?: Record<string, ReactElement> | ReactElement[];
  /** Default fallback content */
  defaults?: string;
  /** Children (can be used as default content) */
  children?: ReactNode;
}

/**
 * Trans component for translations with embedded JSX.
 * Use this when you need to include React components inside translations.
 * 
 * @example
 * // In translation file:
 * // "welcome": "Hello <bold>{{name}}</bold>, click <link>here</link>"
 * 
 * <Trans
 *   i18nKey="welcome"
 *   values={{ name: 'John' }}
 *   components={{
 *     bold: <strong />,
 *     link: <a href="/dashboard" />
 *   }}
 * />
 * 
 * @example
 * // Simple usage
 * <Trans i18nKey="common:messages.success" />
 */
export function Trans({ i18nKey, ns, values, components, defaults, children }: TransProps) {
  return (
    <I18nTrans
      i18nKey={i18nKey}
      ns={ns}
      values={values}
      components={components}
      defaults={defaults}
    >
      {children}
    </I18nTrans>
  );
}

export default Trans;
